import { DesignColor, PrintType } from '@/types';
import { convertColors } from './convertColors';

export const convertDesignColors = (printType: PrintType, colors: DesignColor[]) => {
  const printColors = colors.map((c) => ({ fill: c.origin }));
  return convertColors(printType, printColors);
};
